import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import {
  EvidenceCountsResponse,
  EvidencePlotCount,
  EvidenceShareLink
} from 'src/app/models/evidence.model';
import { environment } from 'src/environments/environment';

/** Evidence column routes; CrdInterceptor adds `crd`. */
@Injectable({
  providedIn: 'root'
})
export class EvidenceService {
  private readonly http = inject(HttpClient);

  // The column shows its own failure states, not the global error dialog.
  private readonly headers = { 'skip-error-interceptor': '1' };

  getCounts(plantationCodes: string[]): Observable<EvidencePlotCount[]> {
    if (plantationCodes.length === 0) {
      return of([]);
    }

    let params = new HttpParams();
    for (const code of plantationCodes) {
      params = params.append('plantation_code', code);
    }

    return this.http
      .get<EvidenceCountsResponse>(
        `${environment.CRD_API}v3/plantations/evidence/counts`,
        { params, headers: this.headers }
      )
      .pipe(map((response) => response.counts));
  }

  mintLink(plantationCode: string): Observable<EvidenceShareLink> {
    return this.http.post<EvidenceShareLink>(
      `${environment.CRD_API}v3/plantations/evidence/link`,
      null,
      {
        params: new HttpParams().set('plantation_code', plantationCode),
        headers: this.headers
      }
    );
  }
}
